import useWidth from '@/helpers/widthUtil';
import { LockOutlined } from '@ant-design/icons';

const PrivateRoomLocked = () => {
  const { isMobile, isTablet } = useWidth();

  return (
    <>
      <div className={`container mb-5 ${isTablet && 'px-0'}`}>
        <div className="row">
          <div className={` ${isMobile && 'px-0'} col-lg-12 discussion-feeds`}>
            <div
              className=" bg-white px-3 py-4 mb-3"
              style={{
                borderRadius: '8px',
                boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
              }}
            >
              <div className="text-center">
                <LockOutlined
                  rev=""
                  style={{ fontSize: '55px' }}
                  className="bg-primary text-white p-3 rounded-circle"
                />
                <h5 className="mt-3 mb-0 ">This group is private</h5>
                <p>Join this group to view or participate in discussions.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivateRoomLocked;
